import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export function RequireAuth() {
    const { isAuthed, loading } = useAuth();
    const loc = useLocation();
    if (loading) return null;
    if (!isAuthed) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
    return <Outlet />;
}

export function RequireRole({ minRole }) {
    const { role } = useAuth();
    if (role < minRole) return <Navigate to="/" replace />;
    return <Outlet />;
}

export function RequirePasswordChange() {
    const { mustChange } = useAuth();
    if (!mustChange) return <Navigate to="/" replace />;
    return <Outlet />;
}
